module.exports = __webpack_public_path__ + "static/img/jxjlright.56e8701.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jxjlright.png
// module id = 4GMR
// module chunks = 1